export default __webpack_public_path__ + "static/media/home-scrollover.5a2e7d42.jpg";